import * as UploadAPI from "../api/upload";
import type { UploadUrlResponse, UploadFields } from "../api/upload";
import * as DummyUploadAPI from "../dummyApi/upload";
import { isDemoMode } from "../stores/mode";

interface UploadAPI {
  uploadFile: (file: File, fields: UploadFields, uploadUrl: string) => Promise<void>
  getUploadUrl: (mimeType: string) => Promise<UploadUrlResponse>
}

const getAPI = (): UploadAPI => isDemoMode() ? DummyUploadAPI : UploadAPI;

export const uploadFile = (file: File, fields: UploadFields, uploadUrl: string): Promise<void> => {
  return getAPI().uploadFile(file, fields, uploadUrl);
};

export const getUploadUrl = (mimeType: string): Promise<UploadUrlResponse> => getAPI().getUploadUrl(mimeType);
